export default __webpack_public_path__ + "static/media/general2024RealCase1-en.9678bd30.jpg";